/**
 * 手工打印标签
 */

<template>

  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">标签管理</el-breadcrumb-item>
      <el-breadcrumb-item>标签打印</el-breadcrumb-item>
    </el-breadcrumb>
    <el-form label-position="left" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="demo-ruleForm login-container">
      <h3 class="title">打印标签</h3>

      <el-form-item prop="MATI_SET_NAME">
        <el-input type="text" v-model="ruleForm.MATI_SET_NAME" auto-complete="off" placeholder="物料名称"></el-input>
      </el-form-item>
      <el-form-item prop="IN_STORE_BATCH_NO">
        <el-input type="text" v-model="ruleForm.IN_STORE_BATCH_NO" auto-complete="off" placeholder="外部采购订单号"></el-input>
      </el-form-item>
      <el-form-item prop="PACKAGE_NO">
        <el-input type="text" v-model="ruleForm.PACKAGE_NO" auto-complete="off" placeholder="箱号"></el-input>
      </el-form-item>
      <el-form-item prop="SKUID">
        <el-input type="text" v-model="ruleForm.SKUID" auto-complete="off" placeholder="SKUID"></el-input>
      </el-form-item>
      <el-form-item prop="SN">
        <el-input type="text" v-model="ruleForm.SN" auto-complete="off" placeholder="SN起始号"></el-input>
      </el-form-item>
      <el-form-item prop="QRCODE_TEXT">
        <el-input type="text" v-model="ruleForm.QRCODE_TEXT" auto-complete="off" placeholder="SN结束号"></el-input>
      </el-form-item>
      <el-form-item prop="totalnumbers">
        <el-input type="text" v-model="ruleForm.numbers" auto-complete="off" placeholder="数量"></el-input>
      </el-form-item>
      <el-form-item prop="packages">
        <el-input type="text" v-model="ruleForm.packages" auto-complete="off" placeholder="第几包"></el-input>
      </el-form-item>
      <el-form-item prop="LOGISTICS_CODE">
        <el-input type="text" v-model="ruleForm.LOGISTICS_CODE" auto-complete="off" placeholder="物流商"></el-input>
      </el-form-item>
      <el-form-item prop="batchNumber">
        <el-input type="text" v-model="ruleForm.batchNumber" auto-complete="off" placeholder="批次号 如110200896-2023111020"></el-input>
      </el-form-item>

      <el-form-item style="width:100%; text-align: center">
        <el-button type="primary" style="width:40%;" @click="submitForm('ruleForm')" :loading="logining">打印</el-button>
        <el-button type="warning" style="width:40%;" @click="reset('ruleForm')" >重置</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="dialogVisible" @close="dislogClosed">

      <p>提示</p>
      <p>生成通知已发送到本地服务器,请到本地服务器查看PDF生成情况,切勿重复操作!!! </p>
      <span slot="footer" class="dialog-footer">
     <el-button @click="dialogVisible = false">关闭</el-button>
     </span>
    </el-dialog>
  </div>


</template>


<script>
  import {
    printlabelone

  } from '../../api/ordersMG'

export default {
  name: "orders",
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      dialogVisible:false,
      ruleForm: {
        MATI_SET_NAME:'',
        IN_STORE_BATCH_NO: '',
        PACKAGE_NO: '',
        SKUID: '',
        SN: '',
        QRCODE_TEXT: '',
        batchNumber: '',
        numbers: '',
        packages: '',
        LOGISTICS_CODE: ''
      },
      //rules前端验证
      rules: {

        MATI_SET_NAME: [{ required: true, message: '请输入物料名称', trigger: 'blur' }],//
        IN_STORE_BATCH_NO: [{ required: true, message: '请输入外部采购单号', trigger: 'blur' }],//
        PACKAGE_NO: [{ required: true, message: '请输入箱号', trigger: 'blur' }] ,//
        SKUID: [{ required: true, message: '请输入SKUID', trigger: 'blur' }],  //
        SN: [{ required: true, message: '请输入SN起始号', trigger: 'blur' }] ,//
        QRCODE_TEXT: [{ required: true, message: '请输入SN结束号', trigger: 'blur' }],//
        numbers: [{ required: true, message: '请输入数量', trigger: 'blur' }] ,//
        packages: [{ required: true, message: '请输入包号', trigger: 'blur' }],//
        LOGISTICS_CODE: [{ required: true, message: '请输入物流商', trigger: 'blur' }],

        batchNumber: [{ required: true, message: '请输入批次号', trigger: 'blur' }]

      }

    }
  },





  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    //获取info列表
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.logining = true;

          printlabelone(this.ruleForm).then(res => {
            this.logining = false

            if (res.code==0) {
              this.logining = false
              this.dialogVisible=true;
              // this.$message({
              //   type: 'info',
              //   message: "打印通知已发送到本地服务器,请注意查看pdf生成情况。 pdf正在生成时，请不要再做其他生成操作，切记！！！"
              // })

            } else {
              console.log();
              this.$message.error(res.msg)

            }
          })
        } else {
          this.logining = false
          return false
        }
      })
    },
    reset()
    {
      this.ruleForm.MATI_SET_NAME="";
      this.ruleForm.IN_STORE_BATCH_NO="";
      this.ruleForm.PACKAGE_NO="";
      this.ruleForm.SKUID="";
      this.ruleForm.SN="";
      this.ruleForm.QRCODE_TEXT="";
      this.ruleForm.batchNumber="";
      this.ruleForm.numbers="";
      this.ruleForm.packages="";
      this.ruleForm.LOGISTICS_CODE="";

    }

  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/views/orders/Label.vue